import axios from 'axios';

const URL = 'https://api.openweathermap.org/data/2.5/weather'; /** getting the APi key from the API point */
const API_KEY = 'ae4b9f1a5e3cedab1ef68d517a6ec2fc';  /**api key from the website */

export const fetchWeather = async (query) => {     /** axios is the connection */
    const { data } = await axios.get(URL, {
        params: {
            q: query,
            units: 'metric',
            APPID: API_KEY,
        }
    });

    return data;
}